var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgLogOutWf = function SvgLogOutWf(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    id: "svg1",
    width: "1em",
    height: "1em"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "g1",
    transform: "translate(0 -4.78)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path1",
    d: "M30.356 11.229a.824.824 0 0 0 1.403.498l-.058.053a.824.824 0 0 1-1.332-.47zm.82-.91a.82.82 0 0 0-.524.19l-.057.051.057-.052a.82.82 0 0 1 .602-.184l.074.011a1 1 0 0 0-.152-.015m-5.284-3.208v8.055L29.9 11.15zm-.772-2.796a.97.97 0 0 1 .712.285l5.885 5.933-.024-.02.024.02.072.072a.82.82 0 0 1 .195.705l-.011.045-.002.006v.003l-.007.025-.012.032-.002.007-.003.008-.01.029-.011.021-.003.007-.006.012-.015.032-.009.014-.002.004-.01.016-.02.034-.006.007-.001.002-.019.024-.022.03-.049.054v.004l-5.929 5.941a.97.97 0 0 1-1.062.214.97.97 0 0 1-.607-.903v-4.895H12.084v-1.726h12.082V5.292a.97.97 0 0 1 .954-.977M0 0h20.714v8.588h-1.726V1.727H1.727v18.987h17.261v-6.905h1.726v8.631H0Z",
    transform: "matrix(.99997 0 0 .99997 0 4.78)"
  }))));
};
export { SvgLogOutWf as ReactComponent };
export default __webpack_public_path__ + "assets/Log Out-WF.f778973e539c70a3efc2873f3821f66d.svg";